module.exports = __webpack_public_path__ + "static/media/afl_football.d402be2b.png";